import React from 'react'
import firebase from 'gatsby-plugin-firebase'
import { Button, Col, Row, Spinner } from 'react-bootstrap';
import Stripe from './Stripe/Stripe'
const Profile = () => {
const [appUser, setUser ] = React.useState({
    isActive : false,
    membershipId : "",
    email : "",
    displayName : "",
    photoURL : "",
    uid : ""
})
const [loader, showLoader] = React.useState('none')
const [loaderText, setLoaderText] = React.useState("")
const [stripeModel, setStripeModel] = React.useState(false)

React.useEffect(() => {
    const data = JSON.parse(localStorage.getItem("AppUser"))
    setUser(data)
},[])

  const showStripe = () => {
    setLoaderText("Deleting Subscription from Weather Pro")
    setStripeModel(true)
  }
 
const logoutUser = () => {
        localStorage.clear()
        firebase.auth().signOut()
        .then(() => {
            localStorage.clear();
            window.location.reload();
        })
    }


const delSubscription = () => {
    setLoaderText("Deleting Subscription from Weather Pro")
    showLoader('block')
    let confirmAction = window.confirm("Are you sure to Unsubscribe from the Premium Plan?")
    if(!confirmAction) {
        showLoader('none')
        return
    }

    fetch(`https://us-central1-weatherapp-3646a.cloudfunctions.net/cancelSubscription?userId=${appUser.uid }`)
        .then(res => res.json())
        .then(response => {
           if(response.success) {
               setUser({
                ...appUser,
                isActive : false
            })
               const data = JSON.parse(localStorage.getItem("AppUser"))
               data.isActive = false
               localStorage.setItem("AppUser" , JSON.stringify(data))
              showLoader('none')
              setLoaderText("")
           }
           else {
               window.alert(response.message)
           }
        })
        .catch(err => {
            window.alert(JSON.stringify(err))
        })
}

return(
    <div style={{height: '100% !important', padding : 15, flex : 1 ,flexDirection : 'column', marginBottom : -20}}>
        <div style={{width:'100%', justifyContent :'center'}}>
            <img style={{
                        widht:100,
                        height:100,
                        borderRadius: '50%',
                    }} src={appUser.photoURL} alt="Profile" />
        </div>
        <Row style={{justifyContent : 'center'}}>
            <h3 className="mt-3" style={{textAlign : 'center'}}> {appUser.displayName}</h3>
        </Row>
        <Row style={{alignSelf:'flex-end', marginTop : 40}}>
            <Col xs={6}>
                {   
                    appUser.isActive?  <p style={{color:'#fff'}}> Membership Activated</p> :  <Button onClick={() => showStripe()} variant="primary" >Upgrade</Button>
                }
            </Col>
            <Col xs={6}>
            <p style={{color:'#FF6600', cursor: 'pointer'}}onClick={() => logoutUser()}>Logout</p>
            </Col>
        </Row>
        <Row>
           {appUser.isActive && <Col xs={6}>
                <p style={{color:'#FF0000', cursor: 'pointer'}}onClick={() => delSubscription()}>Unsubscribe</p>
            </Col>}
        </Row>
        

    <div style={{
        backgroundColor: '#000',
        opacity : 0.8,
        zIndex : '99999',
        justifyContent : 'center',
        flexDirection : 'column',
        alignItems :"center",
        position: 'absolute',
        display : loader,
        paddingTop : 75,
        top:0,bottom:0,left:0,right:0
    }}>
        <Spinner animation="border" variant="success" />
        <br /><br />
        <h5 className="mt-3" style={{textAlign : 'center'}}>{loaderText}</h5>
    </div>
    { stripeModel && 
        <div style={{
            backgroundColor: '#000',
            opacity : 0.91,
            justifyContent : 'center',
            paddingTop : 75,
            position: 'fixed',
            top: 0,
            left: 0,
            width:'100%',
            height: '100%'
        }}>
            <span onClick={() => setStripeModel(false)}
                style={{
                    padding : '5px 15px',
                    fontWeight : 'bold',
                    color : '#fafafa',
                    backgroundColor : 'darkred',
                    position : 'absolute',
                    top : '10px',
                    right : '20px'
                }}
            >X</span>
        <h5 className="mt-3" style={{textAlign : 'center'}}>Subscribe To Weather Pro</h5>
        <Stripe />
    </div>}
    </div>
)
}

export default Profile